import "@popperjs/core";
import "bootstrap";
import { ValidationService } from "aspnet-client-validation";
import "../styles/index.scss";

// ASP.NET Core Client Side Validation Setup
const service = new ValidationService();
service.bootstrap();

class BlazorInterop
{
	// TODO: Add to the UmbrellaBlazorInteropService
	public triggerElementClick(selector: string): void
	{
		(document.querySelector(selector) as HTMLElement)?.click();
	}
}

(window as any).blazorInterop = new BlazorInterop();